import { Validators } from '@angular/forms';

export class QuotesListModel {
  quotesList = {
    value: [],
    validation: Validators.compose([])
  };
}

export class IndividualQuoteModel {
  borrower = {
    value: null,
    validation: Validators.compose([])
  };
  createdDate = {
    value: null,
    validation: Validators.compose([])
  };
}
